import { featuresData } from '@/mocks/homeData';

const iconColors = ['bg-primary-100 text-primary-600', 'bg-accent-100 text-accent-600', 'bg-secondary-100 text-secondary-600'];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{featuresData.title}</h2>
          <p className="text-sm text-foreground-500">{featuresData.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featuresData.items.map((item, idx) => (
            <div key={idx} className="bg-background-50 border border-background-200 rounded-xl p-6 text-center hover:border-primary-200 transition-colors group">
              <span className={`inline-flex w-14 h-14 md:w-16 md:h-16 rounded-2xl items-center justify-center mb-5 ${iconColors[idx]}`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </span>
              <h3 className="text-base font-bold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}